// Pobieranie przycisku .login-trigger i elementu .ct-account-item
var loginTrigger = document.querySelector(".login-trigger");
var accountItem = document.querySelector(".ct-account-item");

// Dodanie nasłuchiwania zdarzeń do przycisku .login-trigger
if (loginTrigger)
  loginTrigger.addEventListener("click", function () {
    // Symulowanie kliknięcia na .ct-account-item
    accountItem.click();
  });
